module.exports = __webpack_public_path__ + "img/magento.3cb90cf9.svg";